import Modal from 'react-modal';
import Axios from 'axios';
import { YouInvest } from 'src/Api';

const customStyles = {
    overlay: {
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        padding: '0',
        margin: '0',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        display: 'block'
    },
};

export default function KeepMeLoggedInModal({modal, setModal}) {
    const closeModal = (event) => {
        event.preventDefault();
        
        setModal(false);
        Axios({
            method: 'GET',
            url: '/keepalive.php',
            headers: YouInvest.getTradingRequestHeaders()
        });
    }

    return <Modal
        isOpen={modal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel={"Log out"}
        preventScroll={true}
        className="modal"
        ariaHideApp={false}
        >
            <div className="modal-content" data-role="dialog" aria-modal="true" aria-label="modal" style={{padding: "20px"}}>
                <h4>Log out</h4>
                <div className="text-align-center">
                    <p className="text-align-left">
                        For your security, you will be logged out of your account due to inactivity. If you would you like to 
                        remain logged in please click the button below.
                    </p>
                </div>
            </div>
            <div className="modal-footer padding-10" style={{height: "auto", background: "white", width: "100%"}}>
                <a data-testid="keepMeLoggedInModalButon" onClick={closeModal} href="" className="modal-close c-btn button-default waves-effect waves-light button button--red watchlist--btn">Keep me logged in</a>
            </div>
    </Modal>
}